import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loan Amount ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Start Date ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" End Date ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Margin ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Base Interest Rate ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Lender Name ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-900" }, "optional", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Calculating... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseInputCurrency = _resolveComponent("BaseInputCurrency")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseInputPercentage = _resolveComponent("BaseInputPercentage")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "is-open": _ctx.isModalOpen,
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setIsModalOpen(false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Heading, {
        tag: "h2",
        class: "text-center md:text-left mb-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.loan.id ? 'Update' : 'Calculate') + " a commercial or personal loan. ", 1)
        ]),
        _: 1
      }),
      _createElementVNode("form", {
        class: "grid md:grid-cols-2 gap-6",
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveLoan && _ctx.saveLoan(...args)), ["prevent"]))
      }, [
        _createVNode(_component_FormRow, { class: "md:col-span-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "loanAmount" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInputCurrency, {
              id: "loanAmount",
              currency: _ctx.loan.loanAmount.currency,
              "onUpdate:currency": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loan.loanAmount.currency) = $event)),
              amount: _ctx.loan.loanAmount.amount,
              "onUpdate:amount": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loan.loanAmount.amount) = $event)),
              placeholder: "Enter loan amount",
              required: ""
            }, null, 8, ["currency", "amount"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "startDate" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInput, {
              id: "startDate",
              modelValue: _ctx.loan.startDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loan.startDate) = $event)),
              type: "date",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "endDate" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInput, {
              id: "endDate",
              modelValue: _ctx.loan.endDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loan.endDate) = $event)),
              type: "date",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "margin" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInputPercentage, {
              id: "margin",
              modelValue: _ctx.loan.margin,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loan.margin) = $event)),
              placeholder: "0.00",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "baseInterestRate" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInputPercentage, {
              id: "baseInterestRate",
              modelValue: _ctx.loan.baseInterestRate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.loan.baseInterestRate) = $event)),
              placeholder: "0.00",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_FormRow, { class: "md:col-span-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseLabel, { for: "lenderName" }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_BaseInput, {
              id: "lenderName",
              modelValue: _ctx.loan.lender,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loan.lender) = $event)),
              placeholder: "(optional)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_PrimaryButton, {
          size: "xl",
          class: "w-full justify-center md:col-span-2",
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Loading, { loading: _ctx.loading }, {
              loader: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.loan.id ? 'Save Changes' : 'Calculate Loan'), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-open"]))
}